<template>
  <ConfirmModal
    v-if="showCheckbox"
    class="confirm-rules-modal"
    :confirm-button-text="confirmText"
    :confirm-button-disabled="!agreed"
    :cancel="'cancel-btn'"
    @cancel="closeModal"
    @confirm="onSave"
  >
    <div class="d-flex flex-column confirm-rules">
      <div class="d-flex mb-5 justify-content-center">
        <h2>{{ $t('_web_tournament_additional_settings_rules', 'Rules') }}</h2>
      </div>
      <TextSection
        class="mb-3 description text-break custom-scrollbar"
        :description="rules"
      />
      <a
        v-if="tournament.rules_link"
        :href="tournament.rules_link"
        class="text-truncate tournament-info_description_rules mt-4 mb-4"
        target="_blank"
      >
        <Icon
          class="icon download-icon"
          name="download"
          :width="20"
          fill="rgba(157, 156, 247, 1)"
        />
        {{ $t('_web_tournaments_info_rules_pdf', 'Download PDF Rules') }}
      </a>
      <label v-if="showCheckbox" class="d-flex align-items-center">
        <Checkbox v-model="agreed" />
        <span class="h-ml-3">
          {{
            $t(
              '_web_tournament_settings_rules-agreed-label',
              'I read and agreed with all tournament rules'
            )
          }}
        </span>
      </label>
    </div>
  </ConfirmModal>
  <div v-else-if="!showCheckbox">
    <ConfirmModal
      class="confirm-rules-modal"
      :confirm-button-text="false"
      :cancel="'cancel-btn'"
      @cancel="closeModal"
    >
      <div class="d-flex flex-column confirm-rules">
        <div class="d-flex mb-5 justify-content-center">
          <h2>
            {{ $t('_web_tournament_additional_settings_rules', 'Rules') }}
          </h2>
        </div>
        <TextSection
          class="mb-3 description text-break custom-scrollbar"
          :description="rules"
        />
        <a
          v-if="tournament.rules_link"
          :href="tournament.rules_link"
          class="text-truncate tournament-info_description_rules mt-4 mb-4"
          target="_blank"
        >
          <Icon
            class="icon download-icon"
            name="download"
            :width="20"
            fill="rgba(157, 156, 247, 1)"
          />
          {{ $t('_web_tournaments_info_rules_pdf', 'Download PDF Rules') }}
        </a>
        <label v-if="showCheckbox" class="d-flex align-items-center">
          <Checkbox v-model="agreed" />
          <span class="h-ml-3">
            {{
              $t(
                '_web_tournament_settings_rules-agreed-label',
                'I read and agreed with all tournament rules'
              )
            }}
          </span>
        </label>
      </div>
    </ConfirmModal>
  </div>
</template>

<script>
import ConfirmModal from '@/components/modal/children/HeraConfirm.vue';
import TextSection from '@/components/text/TextSection.vue';
import Checkbox from '@/components/atoms/form/Checkbox';
import { mapActions } from 'vuex';
import Icon from '@/components/atoms/Icon';
import { prop } from '@/utils/factories';

export default {
  name: 'RulesConfirmModal',
  components: {
    ConfirmModal,
    TextSection,
    Icon,
    Checkbox,
  },

  props: {
    rules: prop(String, ''),
    tournament: prop(Object),
    teamId: prop(String, ''),
    showCheckbox: prop(Boolean, { default: true, required: false }),
  },

  data() {
    return {
      agreed: false,
    };
  },
  computed: {
    confirmText() {
      return this.$t('_web_tournament-agree-confirm', 'Agree');
    },
    cancelText() {
      return this.$t('_web_stage_start_modal_confirmation_cancel', 'Cancel');
    },
  },
  methods: {
    ...mapActions(['closeModal', 'errorNotify']),
    onSave() {
      this.$emit('save', this.tournament, this.teamId);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-rules {
  @include auto-rtl(text-align, left !important);
  margin-left: -1rem;
  margin-right: -1rem;

  .description.text-break {
    white-space: break-spaces;
    max-height: 40vh;
    overflow: auto;
  }

  a {
    color: rgba(157, 156, 247, 1);
  }

  div > h2 {
    text-transform: uppercase;
  }
}

.stages-modal-view {
  border: none;
  padding: 0;
}

.ubheader-text-modal {
  text-transform: uppercase !important;
}
</style>
